import moment from 'moment';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Title } from '@simplybenefits/sb-ui-library';
import ReportOverview from '../Reports/ReportOverview.js';

const reportsData = {
    'Sales Reports': {
        'Block': {
            icon: 'pieChart',
            description: 'Pull a report to review brokerage profitability based on premiums collected and claims paid.',
            testid: 'block',
            hideReportTable: true,
            filters: {
                dateRange: {
                    type: 'date',
                    startDate: moment().startOf('month'),
                    endDate: moment()
                }
            }
        }
    }
};

class Reports extends PureComponent {
    render() {
        const { currentAdvisor } = this.props;

        return (
            <React.Fragment>
                <Title title="Reports Placeholder" />

                <ReportOverview
                    reportSectionData={ reportsData }
                    currentAdvisor={ currentAdvisor }
                />
            </React.Fragment>
        );
    }
}

Reports.propTypes = {
    currentAdvisor: PropTypes.object,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    currentAdvisor: state.advisors.currentAdvisor,
    accessType: state.master.access
});

export default connect(mapStateToProps)(Reports);